import React, { useState }  from "react";
// components
//import HomeNavbar from "../../components/Navbars/HomeNavbar";
import UserLeaveSummary from "../../../components/Cards/UserLeaveSummary.js";

export default function LeaveBalance() {
  
  return (
    <>
      
      <main>
        <div className="relative block py-24 lg:pt-0 ">
          <UserLeaveSummary></UserLeaveSummary>
        </div>
      </main>
      
    </>
  );
}
